import { PlayState, PlayerState } from './enums.js';

export function getApiState(player) {
    const readyDependentState = {
        ready: true,// playerApi.isReady(), // Todo: would this ever NOT be true? By the time we get to this point in the plugin, the player is already technically ready.
        playState: getPlayState(player),
        playerState: getPlayerState(player),
        currentTime: player.currentTime(),
        duration: player.duration(),
        volume: player.volume(),
        muted: player.muted(),
        playbackRate: player.playbackRate()
    };

    const independentState = {
        ready: true,// playerApi.isReady(), // Todo
        playerState: getPlayerState(player),
        liveStatus: player.live?.().status,// playerApi.getLiveStatus(),
        chapters: player.chapters().getAll().map(cue => getMediasiteChapter(cue)),
        timedevents: player.timedEvents().getAll(),// playerApi.getTimedEvents(),
        slides: getAllSlides(player),// playerApi.getSlides(),
        captions: player.captions().get().map(cue => getMediasiteCaption(cue)),
        links: player.metadata().supportingLinks,
        pollsUri: player.polls().url,// playerApi.getPollsUri(),
        allStreams: [],// playerApi.getAllStreams(), // Todo - probably empty array since the new player uses a single composited stream
        visibleStreamTypes: [],// playerApi.getVisibleStreamTypes(), // Todo - probably N/A because of composited video
        pastSessionPlayedSegments: [],// playerApi.getPastSessionPlayedSegments(), // Todo - not in public API. Do we use this anywhere?
        fullscreenInvocationType: []// playerApi.getFullscreenInvocationType() // Todo - not in public API. Do we use this anywhere?
    };

    return Object.assign({}, readyDependentState, independentState);
}

function getPlayState(player) {
    let playState = PlayState.Undefined;

    // Stopped
    if (player.paused() && (player.readyState() === HTMLMediaElement.HAVE_NOTHING)) {
        playState = PlayState.Stopped;
    }

    // Paused
    if (player.paused() && (player.readyState() === HTMLMediaElement.HAVE_ENOUGH_DATA)) {
        playState = PlayState.Paused;
    }

    // Playing
    else if (!player.paused()) {
        playState = PlayState.Playing;
    }

    // ScanForward - needed?
    // ScanReverse - needed?
    // Buffering
    // Waiting - waiting vs. buffering?
    else if (player.paused() && (player.networkState() === HTMLMediaElement.NETWORK_LOADING)) {
        playState = PlayState.Waiting;
    }

    // MediaEnded
    else if (player.paused() && (player.currentTime() === player.duration())) {
        playState = PlayState.MediaEnded;
    }

    // Transitioning - needed?
    // Ready
    // Reconnecting - needed?
    // Closed - needed?
    // Error
    // Opening

    return playState;
}

function getPlayerState(player) {
    let playerState = PlayerState.NotReady;

    // InteractionRequired
    // Waiting
    if (player.networkState() === HTMLMediaElement.NETWORK_LOADING) {
        playerState = PlayerState.Waiting;
    }

    // Playing
    else if (!player.paused()) {
        playerState = PlayerState.Playing;
    }
    // Paused
    else if (player.paused()) {
        playerState = PlayerState.Paused;
    }

    // Stopped
    // Ended
    else if (player.paused() && (player.currentTime() === player.duration())) {
        playerState = PlayerState.Ended;
    }

    // Error

    return playerState;
}

/**
 * @param {VTTCue} cue
 */
function getMediasiteCaption(cue) {
    return {
        text: cue.text,
        time: cue.startTime,
        endTime: cue.endTime
    }
}

/**
 * @param {VTTCue} cue
 */
function getMediasiteChapter(cue) {
    return {
        title: cue.text,
        time: cue.startTime
    }
}

function getAllSlides(player) {
    const slideStream = player.multistream?.().getSlideStream();
    const slides = slideStream?.slideMapping;
    let apiSlides = [];
    if (slides) {
        apiSlides = Object.values(slides).map((slide) => {
            return {
                slideTime: slide.start,
                slideUrl: slide.url
            };
        })
    }

    return apiSlides;
}